import React, { useMemo } from 'react';
import Modal from '../common/ModalPopup';
import * as HELPER from '../config/helper';

type AmountValue = number | string | null | undefined;

interface OffsetAgentCommissionIntroPopupProps {
  show: boolean;
  excessAmount: AmountValue;
  agentCommission: AmountValue;
  onClose: () => void;
  onContinue: () => void;
}

const toAmount = (value: AmountValue) => {
  if (value === null || value === undefined || value === '') return 0;
  const amount = Number(String(value).replace(/[^0-9.-]/g, ''));
  return Number.isFinite(amount) ? amount : 0;
};

const roundAmount = (value: number) => Number(value.toFixed(2));

const formatAmount = (value: AmountValue) => HELPER.addCurrencyFormatting(value);

const formatSignedAmount = (value: AmountValue) => {
  const amount = toAmount(value);
  if (amount < 0) return `- ${formatAmount(Math.abs(amount))}`;
  return formatAmount(amount);
};

const OffsetAgentCommissionIntroPopup: React.FC<OffsetAgentCommissionIntroPopupProps> = ({
  show,
  excessAmount,
  agentCommission,
  onClose,
  onContinue,
}) => {
  const offsetSummary = useMemo(() => {
    const outstandingAmount = Math.abs(toAmount(excessAmount));
    const currentAgentCommission = toAmount(agentCommission);
    const offsetAmount = roundAmount(Math.min(outstandingAmount, currentAgentCommission));

    return {
      offsetAmount,
    };
  }, [agentCommission, excessAmount]);

  return (
    <div className="offset-agent-commission-popup offset-agent-commission-popup--intro view-timeline-popup image-timeline-popup">
      <Modal show={show} handleClose={onClose}>
        <div className="modal-header">
          <h2>Offset Agent Commission</h2>
        </div>
        <div className="modal-body">
          <div className="offset-agent-commission-popup__summary">
            <div className="offset-agent-commission-popup__row offset-agent-commission-popup__row--muted">
              <span>Excess Amount with OTO</span>
              <strong className="offset-agent-commission-popup__amount offset-agent-commission-popup__amount--danger">
                {formatSignedAmount(excessAmount)}
              </strong>
            </div>

            <div className="offset-agent-commission-popup__row offset-agent-commission-popup__row--muted">
              <span>Agent Commission</span>
              <strong className="offset-agent-commission-popup__amount">
                {formatAmount(agentCommission)}
              </strong>
            </div>

            <div className="offset-agent-commission-popup__offset-row">
              <span>Offset Agent Commission Amount</span>
              <button
                type="button"
                className="offset-agent-commission-popup__offset-amount"
                onClick={onContinue}
                disabled={offsetSummary.offsetAmount <= 0}
              >
                {formatAmount(offsetSummary.offsetAmount)}
              </button>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn-line" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary"
            disabled
          >
            Confirm
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default OffsetAgentCommissionIntroPopup;
